export const PROCEED_EVENT_NAME = 'proceed'
export const LOAD_EVENT_NAME = 'load'
export const DEFAULT_TITLE_KEY = 'name'
export const DEFAULT_VALUE_KEY = 'id'
export const DESTINATION_PRIORITY_IDS = ['999', '998', '997', '081', '102', '077', '202']
export const DESTINATION_MASK_CONFIG = {
  mask: 'X'.repeat(120),
  tokens: {
    X: {
      pattern: /[a-zA-Z\u0600-\u06FF]/,
    },
  },
}
